import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DeviceTask } from '@rocksoft/device-task-management-sdk';
import { DeviceScheduledTasksCancelContainerComponent } from './device-scheduled-tasks-cancel/device-scheduled-tasks-cancel.container';

@Component({
  selector: 'era-device-scheduled-tasks-ui',
  templateUrl: './device-scheduled-tasks.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [FaIconComponent, DeviceScheduledTasksCancelContainerComponent],
})
export class DeviceScheduledTasksComponent {
  readonly scheduledTasks = input.required<DeviceTask[]>();
  readonly deleteEvent = output<DeviceTask>();

  public convertScheduledTask(task: string): string {
    const taskWithUppercase = task.charAt(0).toUpperCase() + task.slice(1);
    return taskWithUppercase.split('-').join(' ');
  }

  public deleteScheduledTask(event: DeviceTask) {
    this.deleteEvent.emit(event);
  }
}
